export function requestHygieneNotificationPermission() {
  if (typeof window === "undefined" || !("Notification" in window)) return;
  if (Notification.permission === "default") {
    Notification.requestPermission().catch(() => {});
  }
}

export function notifyHygieneJobComplete({ scanned = 0, issuesFound = 0 } = {}) {
  if (typeof window === "undefined" || !("Notification" in window)) return;
  if (Notification.permission !== "granted") return;

  const body = `${scanned} cadastro(s) analisado(s), ${issuesFound} inconsistência(s) encontrada(s).`;
  try {
    new Notification("Varredura de cadastros concluída", { body, tag: "client-hygiene-complete" });
  } catch {
    /* ignore */
  }
}
